import { makeStyles } from '@material-ui/core/styles';

const useStyles = () => ({
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'flex-end'
  }
});

export default makeStyles(useStyles);
